import React from "react";
import { Image } from "antd";
const Logo = React.memo((props) => {
    const { appLogo } = props;
    return (
        <div className="d-flex gap-2">
            <Image
                className="right-logo"
                src={appLogo}
                preview={false}
                draggable={false}
                height={45}
                style={{ width: "auto" }}
            />
        </div>
    );
});

export default Logo;
